import { render, staticRenderFns } from "./AsignacionPersonal.vue?vue&type=template&id=5e585801&"
import script from "./AsignacionPersonal.vue?vue&type=script&lang=ts&"
export * from "./AsignacionPersonal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5e585801', component.options)
    } else {
      api.reload('5e585801', component.options)
    }
    module.hot.accept("./AsignacionPersonal.vue?vue&type=template&id=5e585801&", function () {
      api.rerender('5e585801', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Asignaciones/AsignacionPersonal.vue"
export default component.exports